var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { "data-test": "custom-invoice-form" } },
    [
      _c("v-card-title", [
        _vm._v(
          _vm._s(
            _vm.readonly
              ? "Individuelle Rechnung"
              : _vm.invoice
              ? "Rechnung bearbeiten"
              : "Individuelle Rechnung erstellen"
          )
        ),
      ]),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _vm.error
            ? _c(
                "v-alert",
                {
                  attrs: {
                    type: "error",
                    outlined: "",
                    "data-test": "custom-invoice-error",
                  },
                },
                [_vm._v(_vm._s(_vm.error))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mb-4",
              attrs: { "data-test": "custom-invoice-recipient" },
            },
            [
              _c("strong", [_vm._v(_vm._s(_vm.recipient.name))]),
              _c("br"),
              _vm._v("\n            " + _vm._s(_vm.recipient.street)),
              _c("br"),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.recipient.zip) +
                  " " +
                  _vm._s(_vm.recipient.city)
              ),
              _c("br"),
              _vm._v(
                "\n            Kundennummer: " +
                  _vm._s(_vm.recipient.customer_id) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Die Rechnungsadresse wird aus den Stammdaten übernommen und auf der Rechnung gespeichert."
            ),
          ]),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "header",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.next.apply(null, arguments)
                },
              },
            },
            [
              _c("v-text-field", {
                attrs: {
                  name: "rn_name",
                  label: "RN-Name",
                  rules: [_vm.validators.required],
                  readonly: _vm.readonly,
                  disabled: _vm.busy,
                },
                model: {
                  value: _vm.form.rn_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "rn_name", $$v)
                  },
                  expression: "form.rn_name",
                },
              }),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  name: "invoice_year",
                  label: "Rechnungsjahr",
                  type: "number",
                  min: "1000",
                  max: "9999",
                  step: "1",
                  hint: "Dieses Jahr wird für die Rechnungsreferenz verwendet.",
                  "persistent-hint": "",
                  rules: [_vm.validators.required],
                  readonly: _vm.readonly,
                  disabled: _vm.busy,
                },
                model: {
                  value: _vm.form.invoice_year,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "invoice_year", _vm._n($$v))
                  },
                  expression: "form.invoice_year",
                },
              }),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  name: "invoice_date",
                  label: "Rechnungsdatum",
                  type: "date",
                  rules: [_vm.validators.required],
                  readonly: _vm.readonly,
                  disabled: _vm.busy,
                },
                model: {
                  value: _vm.form.invoice_date,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "invoice_date", $$v)
                  },
                  expression: "form.invoice_date",
                },
              }),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  name: "payment_due_date",
                  label: "Zahlungsziel",
                  type: "date",
                  rules: [_vm.validators.required],
                  readonly: _vm.readonly,
                  disabled: _vm.busy,
                },
                model: {
                  value: _vm.form.payment_due_date,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "payment_due_date", $$v)
                  },
                  expression: "form.payment_due_date",
                },
              }),
              _vm._v(" "),
              _c("v-textarea", {
                attrs: {
                  name: "internal_note",
                  label: "Interne Notiz (optional)",
                  readonly: _vm.readonly,
                  disabled: _vm.busy,
                  rows: "2",
                },
                model: {
                  value: _vm.form.internal_note,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "internal_note", $$v)
                  },
                  expression: "form.internal_note",
                },
              }),
              _vm._v(" "),
              !_vm.itemsVisible
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        type: "submit",
                        color: "primary",
                        "data-test": "custom-invoice-header-next",
                      },
                    },
                    [_vm._v("Positionen erfassen")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.itemsVisible
            ? _c(
                "v-form",
                {
                  ref: "items",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.save.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._l(_vm.form.items, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "mt-4",
                        attrs: { "data-test": "custom-invoice-item" },
                      },
                      [
                        _c("h3", [_vm._v("Position " + _vm._s(index + 1))]),
                        _vm._v(" "),
                        _c("v-text-field", {
                          attrs: {
                            name: "item_name",
                            label: "Bezeichnung",
                            rules: [_vm.validators.required],
                            readonly: _vm.readonly,
                            disabled: _vm.busy,
                          },
                          model: {
                            value: item.name,
                            callback: function ($$v) {
                              _vm.$set(item, "name", $$v)
                            },
                            expression: "item.name",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    name: "item_net",
                                    label: "Nettobetrag (€)",
                                    rules: [_vm.validators.decimal],
                                    readonly: _vm.readonly,
                                    disabled: _vm.busy,
                                  },
                                  model: {
                                    value: item.net_amount,
                                    callback: function ($$v) {
                                      _vm.$set(item, "net_amount", $$v)
                                    },
                                    expression: "item.net_amount",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    name: "item_vat",
                                    label: "MwSt. (%)",
                                    rules: [_vm.validators.decimal],
                                    readonly: _vm.readonly,
                                    disabled: _vm.busy,
                                  },
                                  model: {
                                    value: item.vat_rate,
                                    callback: function ($$v) {
                                      _vm.$set(item, "vat_rate", $$v)
                                    },
                                    expression: "item.vat_rate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    name: "item_period_start",
                                    label: "Leistung von (optional)",
                                    type: "date",
                                    readonly: _vm.readonly,
                                    disabled: _vm.busy,
                                  },
                                  model: {
                                    value: item.service_period_start,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        item,
                                        "service_period_start",
                                        $$v
                                      )
                                    },
                                    expression: "item.service_period_start",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    name: "item_period_end",
                                    label: "Leistung bis (optional)",
                                    type: "date",
                                    readonly: _vm.readonly,
                                    disabled: _vm.busy,
                                  },
                                  model: {
                                    value: item.service_period_end,
                                    callback: function ($$v) {
                                      _vm.$set(item, "service_period_end", $$v)
                                    },
                                    expression: "item.service_period_end",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.readonly
                          ? _c("p", [
                              _vm._v(
                                "MwSt.: " +
                                  _vm._s(
                                    _vm.money(
                                      _vm.invoice.items[index].vat_amount
                                    )
                                  ) +
                                  " · Brutto: " +
                                  _vm._s(
                                    _vm.money(
                                      _vm.invoice.items[index].gross_amount
                                    )
                                  )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.readonly
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  disabled:
                                    _vm.busy || _vm.form.items.length === 1,
                                  text: "",
                                  color: "error",
                                  "data-test": "custom-invoice-remove-item",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.form.items.splice(index, 1)
                                  },
                                },
                              },
                              [_vm._v("Position entfernen")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("v-divider", { staticClass: "mt-3" }),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  !_vm.readonly
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "my-4",
                          attrs: {
                            disabled: _vm.busy,
                            "data-test": "custom-invoice-add-item",
                          },
                          on: { click: _vm.addItem },
                        },
                        [_vm._v("Position hinzufügen")]
                      )
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.readonly
            ? _c(
                "div",
                {
                  staticClass: "mt-4",
                  attrs: { "data-test": "custom-invoice-totals" },
                },
                [
                  _c("p", [
                    _vm._v("Referenz: "),
                    _c("strong", [_vm._v(_vm._s(_vm.invoice.reference))]),
                  ]),
                  _vm._v(" "),
                  _c("v-simple-table", [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("MwSt.-Satz")]),
                        _c("th", [_vm._v("Netto")]),
                        _c("th", [_vm._v("MwSt.")]),
                        _c("th", [_vm._v("Brutto")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.invoice.vat_totals, function (group) {
                          return _c("tr", { key: group.vat_rate }, [
                            _c("td", [_vm._v(_vm._s(group.vat_rate) + " %")]),
                            _c("td", [
                              _vm._v(_vm._s(_vm.money(group.net_amount))),
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(_vm.money(group.vat_amount))),
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(_vm.money(group.gross_amount))),
                            ]),
                          ])
                        }),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", [_vm._v("Gesamt")]),
                          _c("th", [
                            _vm._v(_vm._s(_vm.money(_vm.invoice.net_amount))),
                          ]),
                          _c("th", [
                            _vm._v(_vm._s(_vm.money(_vm.invoice.vat_amount))),
                          ]),
                          _c("th", [
                            _vm._v(_vm._s(_vm.money(_vm.invoice.gross_amount))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "mt-4" }, [_vm._v("Verlauf")]),
                  _vm._v(" "),
                  _c("v-simple-table", [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Aktion")]),
                        _c("th", [_vm._v("Zeitpunkt")]),
                        _c("th", [_vm._v("Administrator")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.invoice.audit, function (event, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [
                            _vm._v(_vm._s(_vm.auditLabels[event.event])),
                          ]),
                          _c("td", [_vm._v(_vm._s(_vm.$formatDate(event.at)))]),
                          _c("td", [_vm._v(_vm._s(event.by))]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ],
                1
              )
            : _c("p", { staticClass: "mt-4" }, [
                _vm._v(
                  "Beim Speichern werden die Beträge berechnet. Der Entwurf wird weder übertragen noch versendet."
                ),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        { staticClass: "justify-end" },
        [
          _c(
            "v-btn",
            {
              attrs: {
                disabled: _vm.busy,
                text: "",
                "data-test": "custom-invoice-close",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v("Schließen")]
          ),
          _vm._v(" "),
          !_vm.readonly && _vm.itemsVisible
            ? _c(
                "v-btn",
                {
                  attrs: {
                    loading: _vm.busy,
                    disabled: _vm.busy,
                    color: "primary",
                    "data-test": "custom-invoice-save",
                  },
                  on: { click: _vm.save },
                },
                [_vm._v("Entwurf speichern")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }